// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"cfe233e502bd9dc6b7df","293":"73a59850a74826a07e77","518":"a2bf7234b9d61ec1013e","779":"7c59cefba127095194ce"}[chunkId] + ".js";
};